import React from 'react';
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';
import { useLocation } from 'react-router-dom';
import SpotlightTour from './SpotlightTour';

/** First-visit tour inside a live contest arena only — not the /contests list. */
export const CONTESTS_TOUR_KEY = 'ch_live_contest_tour_v1';
export const CONTESTS_TOUR_START_EVENT = 'ch-start-contests-tour';
export const CONTESTS_TOUR_COMPLETE_EVENT = 'ch-contests-tour-complete';

const steps = [
  {
    id: 'welcome',
    placement: 'center',
    eyebrow: 'Contest arena',
    title: 'You’re in — clock is running',
    body: 'Solve any problem in any order. The timer is shared across the set — Final submit when you’re done.',
    cta: 'Show me around',
  },
  {
    id: 'header',
    target: '[data-tour="live-contest-header"]',
    placement: 'bottom',
    eyebrow: 'Stay on the clock',
    title: 'Timer & Final submit',
    body: 'Watch Time left in the header. When you’re finished (or out of time), use Final submit to lock your score.',
  },
  {
    id: 'problems',
    target: '[data-tour="live-contest-problems"]',
    placement: 'right',
    eyebrow: 'Your set',
    title: 'Pick problems A, B, C…',
    body: 'Open any question from the rail. You can jump between problems anytime — your work stays until you submit the contest.',
  },
  {
    id: 'workspace',
    target: '[data-tour="live-contest-workspace"]',
    placement: 'left',
    eyebrow: 'Solve here',
    title: 'Read, code, run',
    body: 'The workspace is the same editor you know — read the statement, write code, Run to test, then move on to the next problem.',
  },
  {
    id: 'finish',
    placement: 'center',
    eyebrow: "You're set",
    title: 'Go crush the round',
    body: 'Replay this tour anytime with the help icon in the arena header. Good luck!',
    cta: 'Start solving',
  },
];

const ContestsPageTour = () => {
  const location = useLocation();
  // /contests/:contestId/live
  const active = /^\/contests\/[^/]+\/live\/?$/.test(location.pathname);

  return (
    <SpotlightTour
      steps={steps}
      storageKey={CONTESTS_TOUR_KEY}
      startEvent={CONTESTS_TOUR_START_EVENT}
      completeEvent={CONTESTS_TOUR_COMPLETE_EVENT}
      active={active}
      autoStartDelay={1200}
      isReady={() =>
        Boolean(
          document.querySelector('[data-tour="live-contest-header"]') &&
            document.querySelector('[data-tour="live-contest-workspace"]'),
        )
      }
      finishIcon={<EmojiEventsOutlinedIcon sx={{ fontSize: 14 }} />}
    />
  );
};

export default ContestsPageTour;
